export default __webpack_public_path__ + "static/media/stagger2.34e3a3e2.png";